import api from "./Api";
import Swal from "sweetalert2";

class DemonstracaoService {

  async jaSolicitado(recurso: string): Promise<boolean> {
    try {
      const { data } = await api.get<{ jaSolicitado: boolean }>('Demonstracao/ja-solicitado', { params: { recurso } });
      return data.jaSolicitado;
    } catch (error: any) {
      console.error('DemonstracaoService.jaSolicitado falhou:', error?.response?.status, error?.response?.data ?? error.message);
      return false;
    }
  }

  async solicitar(recurso: string): Promise<boolean> {
    try {
      await api.post('Demonstracao/solicitar', { recurso });
      return true;
    } catch (error: any) {
      console.error('DemonstracaoService.solicitar falhou:', error?.response?.status, error?.response?.data ?? error.message);
      Swal.fire({ text: error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return false;
    }
  }
}

export default new DemonstracaoService();
